import theme from './constants/theme-constants';

export default async function getAssets() {
  // add assets into a folder and move to the branding folder. 
  // then link those assets here 
  switch (process.env.REACT_APP_THEME) {
    case theme.sr:
      return {
        logo: await import('./assets/brandings/logo.svg'),
        banner: await import('./assets/brandings/banner.svg'),
        nosearchresultno: await import('./assets/images/not-found/no-results-nr.png'),
        nosearchresulten: await import('./assets/images/not-found/no-results-eng.png')
      };
    case theme.ue:
      return {
        logo: await import('./assets/brandings/logo.svg'),
        banner: await import('./assets/brandings/banner.svg'),
        nosearchresultno: await import('./assets/images/not-found/no-results-nr.png'),
        nosearchresulten: await import('./assets/images/not-found/no-results-eng.png')
      };
    case theme.bruno:
      return {
        logo: await import('./assets/brandings/logo.svg'),
        banner: await import('./assets/brandings/banner.svg'),
        nosearchresultno: await import('./assets/images/not-found/no-results-nr.png'),
        nosearchresulten: await import('./assets/images/not-found/no-results-eng.png')
      };
    case theme.sample:
      return {
        logo: await import('./assets/brandings/sample/logo.png'),
        banner: await import('./assets/brandings/sample/banner.png'),
        nosearchresultno: await import('./assets/images/not-found/no-results-nr.png'),
        nosearchresulten: await import('./assets/images/not-found/no-results-eng.png')
      };
    case theme.softrig:
      return {
        logo: await import('./assets/brandings/softrig/logo.svg'),
        banner: await import('./assets/brandings/softrig/banner.svg'),
        nosearchresultno: await import('./assets/brandings/softrig/images/not-found/no-results-eng.svg'),
        nosearchresulten: await import('./assets/brandings/softrig/images/not-found/no-results-eng.svg')
      };
    default:
      return {
        logo: await import('./assets/brandings/logo.svg'),
        banner: await import('./assets/brandings/banner.svg'),
        nosearchresultno: await import('./assets/images/not-found/no-results-nr.png'),
        nosearchresulten: await import('./assets/images/not-found/no-results-eng.png')
      };
  }
}